import { api } from "@/api/client";
import type { BrandSignature, BrandView } from "@/types/api";

export interface BrandCreate {
  key: string;
  display_name: string;
  mp_aliases: string[];
  brand_context: string | null;
  signatures: BrandSignature[];
  signature_required: boolean;
  is_enabled: boolean;
}

export interface BrandUpdate {
  display_name?: string;
  mp_aliases?: string[];
  brand_context?: string | null;
  signatures?: BrandSignature[];
  signature_required?: boolean;
  is_enabled?: boolean;
}

// Per-role link update. A field absent = unchanged; null = remove; number = set.
export interface BrandLinksUpdate {
  classifier?: number | null;
  generator?: number | null;
  critic?: number | null;
}

export async function listBrands(): Promise<BrandView[]> {
  const { data } = await api.get<BrandView[]>("/brands");
  return data;
}

export async function getBrand(id: number): Promise<BrandView> {
  const { data } = await api.get<BrandView>(`/brands/${id}`);
  return data;
}

export async function createBrand(body: BrandCreate): Promise<BrandView> {
  const { data } = await api.post<BrandView>("/brands", body);
  return data;
}

export async function updateBrand(id: number, body: BrandUpdate): Promise<BrandView> {
  const { data } = await api.put<BrandView>(`/brands/${id}`, body);
  return data;
}

export async function deleteBrand(id: number): Promise<void> {
  await api.delete(`/brands/${id}`);
}

export async function updateBrandLinks(
  id: number,
  body: BrandLinksUpdate,
): Promise<BrandView> {
  const { data } = await api.put<BrandView>(`/brands/${id}/links`, body);
  return data;
}
